import * as yup from "yup";
import { Length, Max, Min, Validation } from "../../utils/Validation.utils";
export const LocationInitialValues = {
    name: "",
    address1: "",
    address2: "",
    city: "",
    stateName: null,
    postalCode: "",
    latitude: 0,
    longitude: 0,
    isPrimary: false
};
export const LocationSchema = yup.object().shape({
    name: yup
        .string()
        .min(Min.Name, Validation.Min)
        .max(Max.LongName, Validation.Max)
        .required(Validation.Required),
    address1: yup
        .string()
        .min(0, Validation.Min)
        .max(Max.Address, Validation.Max)
        .optional(),
    address2: yup
        .string()
        .min(0, Validation.Min)
        .max(Max.Address, Validation.Max)
        .optional(),
    city: yup.string().max(Max.City, Validation.Max).optional(),
    stateName: yup.string().max(Max.State, Validation.Max).optional(),
    postalCode: yup
        .string()
        .length(Length.PostalCode, Validation.Length)
        .optional(),
    latitude: yup.number().optional(),
    longitude: yup.number().optional(),
    isPrimary: yup
        .boolean()
        .optional()
        .transform((value) => Boolean(!!value))
});
